import classNames from 'classnames';
import { type FC } from 'react';

import s from './styles.module.scss';

interface IProps {
  value?: string | null;
}

const BaseRichText: FC<IProps> = ({ value = '' }) => {
  return value ? (
    <span
      className={classNames(s['rich-text'], 'ql-editor', 'ql-index-1')}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  ) : (
    <span />
  );
};

export default BaseRichText;
